import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/forms";
import * as i3 from "./header-button.component";
const _c0 = ["DataTable-table-header", ""];
function DataTableHeaderComponent_tr_0_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 4)(1, "span", 5);
    i0.ɵɵtext(2, "Details");
    i0.ɵɵelementEnd()();
} }
function DataTableHeaderComponent_tr_0_th_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function DataTableHeaderComponent_tr_0_th_2_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); const i_r4 = ctx_r13.index; const column_r3 = ctx_r13.$implicit; const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.moveColumnBackward(i_r4, column_r3)); });
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const column_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", "order-" + ctx_r7.tableId + "-" + column_r3.property + "-left");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate("Move the " + column_r3.header + " column left");
} }
function DataTableHeaderComponent_tr_0_th_2_DataTable_table_header_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "DataTable-table-header-button", 13);
    i0.ɵɵlistener("sortChange", function DataTableHeaderComponent_tr_0_th_2_DataTable_table_header_button_2_Template_DataTable_table_header_button_sortChange_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r16.dispatchSortChangeEvent($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("column", column_r3);
} }
function DataTableHeaderComponent_tr_0_th_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r3.header, " ");
} }
function DataTableHeaderComponent_tr_0_th_2_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function DataTableHeaderComponent_tr_0_th_2_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); const i_r4 = ctx_r21.index; const column_r3 = ctx_r21.$implicit; const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.moveColumnForward(i_r4, column_r3)); });
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const column_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", "order-" + ctx_r10.tableId + "-" + column_r3.property + "-right");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate("Move the " + column_r3.header + " column right");
} }
function DataTableHeaderComponent_tr_0_th_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 16);
    i0.ɵɵlistener("ngModelChange", function DataTableHeaderComponent_tr_0_th_2_div_5_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r26); const column_r3 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(column_r3.filter = $event); })("ngModelChange", function DataTableHeaderComponent_tr_0_th_2_div_5_Template_input_ngModelChange_3_listener() { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r27.fireFilterChange()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext();
    const i_r4 = ctx_r28.index;
    const column_r3 = ctx_r28.$implicit;
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", "column-filter-" + ctx_r11.tableId + "-" + i_r4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", column_r3.header, " filter");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("name", "column", i_r4, "");
    i0.ɵɵproperty("id", "column-filter-" + ctx_r11.tableId + "-" + i_r4)("ngModel", column_r3.filter);
    i0.ɵɵattribute("placeholder", ctx_r11.showFilterPlaceholders ? column_r3.header + " filter" : null);
} }
const _c1 = function (a0, a1) { return { right: a0, "button-column": a1 }; };
function DataTableHeaderComponent_tr_0_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 6);
    i0.ɵɵtemplate(1, DataTableHeaderComponent_tr_0_th_2_button_1_Template, 3, 2, "button", 7);
    i0.ɵɵtemplate(2, DataTableHeaderComponent_tr_0_th_2_DataTable_table_header_button_2_Template, 1, 1, "DataTable-table-header-button", 8);
    i0.ɵɵtemplate(3, DataTableHeaderComponent_tr_0_th_2_ng_container_3_Template, 2, 1, "ng-container", 9);
    i0.ɵɵtemplate(4, DataTableHeaderComponent_tr_0_th_2_button_4_Template, 3, 2, "button", 10);
    i0.ɵɵtemplate(5, DataTableHeaderComponent_tr_0_th_2_div_5_Template, 4, 6, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const f_r5 = ctx.first;
    const l_r6 = ctx.last;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("header-buttons ", column_r3.customClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c1, column_r3.alignRight, ctx_r2.sortable && !column_r3.unsortable));
    i0.ɵɵattribute("id", "column" + ctx_r2.tableId + "-" + i_r4 + "-" + column_r3.property)("aria-sort", !ctx_r2.sortable || column_r3.unsortable ? null : column_r3.sortType === undefined || column_r3.sortType === 0 ? "none" : column_r3.sortType === 1 ? "ascending" : "descending");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.columnOrdering && !f_r5 && !column_r3.disableOrdering);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.sortable && !column_r3.unsortable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.sortable || column_r3.unsortable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.columnOrdering && !l_r6 && !column_r3.disableOrdering);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.columnFiltering && ctx_r2.filterable && !column_r3.hideHeaderFilter);
} }
function DataTableHeaderComponent_tr_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 1);
    i0.ɵɵtemplate(1, DataTableHeaderComponent_tr_0_th_1_Template, 3, 0, "th", 2);
    i0.ɵɵtemplate(2, DataTableHeaderComponent_tr_0_th_2_Template, 6, 14, "th", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.childRows);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.currentColumns);
} }
export class DataTableHeaderComponent {
    constructor(document) {
        this.document = document;
        this.sortChange = new EventEmitter();
        this.filterChange = new EventEmitter();
        this.columnChange = new EventEmitter();
    }
    dispatchSortChangeEvent(event) {
        this.sortChange.emit(event);
    }
    fireFilterChange() {
        this.filterChange.emit({
            columns: this.allColumns,
            filter: this.filter,
            localPagingSize: this.localPagingSize,
        });
    }
    moveColumnForward(index, column) {
        this.move(index, 1, column);
        this.notifierService.postMessage('column moved right');
        const newIndex = this.currentColumns.indexOf(column);
        setTimeout(() => {
            if (newIndex === this.currentColumns.length - 1) {
                this.focusButton(column, 'left');
            }
            else {
                this.focusButton(column, 'right');
            }
        }, 100);
    }
    moveColumnBackward(index, column) {
        this.move(index, -1, column);
        this.notifierService.postMessage('column moved left');
        const newIndex = this.currentColumns.indexOf(column);
        setTimeout(() => {
            if (newIndex === 0) {
                this.focusButton(column, 'right');
            }
            else {
                this.focusButton(column, 'left');
            }
        }, 100);
    }
    focusButton(column, dir) {
        const button = document.getElementById(column.property + '-' + dir);
        if (button) {
            button.focus();
        }
    }
    move(index, offset, column) {
        const newIndex = index + offset;
        if (newIndex > -1 && newIndex < this.currentColumns.length) {
            const allStartIndex = this.allColumns.indexOf(column);
            let start = allStartIndex;
            let adjust = 0;
            if (offset < 0) {
                // if going backwards, look backwards for hidden
                adjust = -1;
                while (start >= 0) {
                    start--;
                    const col = this.allColumns[start];
                    if (col && !col.displayed) {
                        --adjust;
                    }
                    else {
                        break;
                    }
                }
            }
            else {
                // else look forwards for hidden
                adjust = 1;
                while (start <= this.allColumns.length) {
                    start++;
                    const col = this.allColumns[start];
                    if (col && !col.displayed) {
                        ++adjust;
                    }
                    else {
                        break;
                    }
                }
            }
            const removedElementAll = this.allColumns.splice(allStartIndex, 1)[0];
            this.allColumns.splice(allStartIndex + adjust, 0, removedElementAll);
            this.columnChange.emit(this.allColumns);
        }
    }
}
DataTableHeaderComponent.ɵfac = function DataTableHeaderComponent_Factory(t) { return new (t || DataTableHeaderComponent)(i0.ɵɵdirectiveInject(DOCUMENT)); };
DataTableHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataTableHeaderComponent, selectors: [["", "DataTable-table-header", ""]], inputs: { tableId: "tableId", sortable: "sortable", allColumns: "allColumns", currentColumns: "currentColumns", columnOrdering: "columnOrdering", childRows: "childRows", page: "page", filterable: "filterable", columnFiltering: "columnFiltering", filter: "filter", showFilterPlaceholders: "showFilterPlaceholders", notifierService: "notifierService", localPagingSize: "localPagingSize" }, outputs: { sortChange: "sortChange", filterChange: "filterChange", columnChange: "columnChange" }, attrs: _c0, decls: 1, vars: 1, consts: [["class", "header-row header-border", 4, "ngIf"], [1, "header-row", "header-border"], ["class", "childHeader child-spacer", "scope", "col", 4, "ngIf"], ["scope", "col", 3, "class", "ngClass", 4, "ngFor", "ngForOf"], ["scope", "col", 1, "childHeader", "child-spacer"], [1, "screen-reader"], ["scope", "col", 3, "ngClass"], ["type", "button", "class", "ordering-button fa fa-angle-left", 3, "id", "click", 4, "ngIf"], [3, "column", "sortChange", 4, "ngIf"], [4, "ngIf"], ["type", "button", "class", "ordering-button fa fa-angle-right", 3, "id", "click", 4, "ngIf"], ["type", "button", 1, "ordering-button", "fa", "fa-angle-left", 3, "id", "click"], [1, "screen-reader-button-label"], [3, "column", "sortChange"], ["type", "button", 1, "ordering-button", "fa", "fa-angle-right", 3, "id", "click"], [1, "screen-reader", 3, "for"], ["type", "text", 3, "name", "id", "ngModel", "ngModelChange"]], template: function DataTableHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DataTableHeaderComponent_tr_0_Template, 3, 2, "tr", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.currentColumns.length > 0);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i3.DataTableHeaderButtonComponent], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableHeaderComponent, [{
        type: Component,
        args: [{ selector: '[DataTable-table-header]', template: `
    <tr class="header-row header-border" *ngIf="currentColumns.length > 0">
      <th *ngIf="childRows" class="childHeader child-spacer" scope="col">
        <span class="screen-reader">Details</span>
      </th>
      <th
        class="header-buttons {{ column.customClass }}"
        [ngClass]="{
          right: column.alignRight,
          'button-column': sortable && !column.unsortable
        }"
        *ngFor="let column of currentColumns; let i = index; let f = first; let l = last"
        [attr.id]="'column' + tableId + '-' + i + '-' + column.property"
        [attr.aria-sort]="
          !sortable || column.unsortable
            ? null
            : column.sortType === undefined || column.sortType === 0
            ? 'none'
            : column.sortType === 1
            ? 'ascending'
            : 'descending'
        "
        scope="col"
      >
        <button
          *ngIf="columnOrdering && !f && !column.disableOrdering"
          (click)="moveColumnBackward(i, column)"
          type="button"
          class="ordering-button fa fa-angle-left"
          [id]="'order-' + tableId + '-' + column.property + '-left'"
        >
          <span class="screen-reader-button-label">{{ 'Move the ' + column.header + ' column left' }}</span>
        </button>
        <DataTable-table-header-button
          *ngIf="sortable && !column.unsortable"
          [column]="column"
          (sortChange)="dispatchSortChangeEvent($event)"
        ></DataTable-table-header-button>
        <ng-container *ngIf="!sortable || column.unsortable">
          {{ column.header }}
        </ng-container>
        <button
          *ngIf="columnOrdering && !l && !column.disableOrdering"
          (click)="moveColumnForward(i, column)"
          type="button"
          class="ordering-button fa fa-angle-right"
          [id]="'order-' + tableId + '-' + column.property + '-right'"
        >
          <span class="screen-reader-button-label">{{ 'Move the ' + column.header + ' column right' }}</span>
        </button>
        <div *ngIf="columnFiltering && filterable && !column.hideHeaderFilter">
          <label [for]="'column-filter-' + tableId + '-' + i" class="screen-reader"
            >{{ column.header }} filter</label
          >
          <input
            type="text"
            name="column{{ i }}"
            [id]="'column-filter-' + tableId + '-' + i"
            [(ngModel)]="column.filter"
            (ngModelChange)="fireFilterChange()"
            [attr.placeholder]="showFilterPlaceholders ? column.header + ' filter' : null"
          />
        </div>
      </th>
    </tr>
  `, styles: ["/*# sourceMappingURL=table.component.css.map */\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { tableId: [{
            type: Input
        }], sortable: [{
            type: Input
        }], allColumns: [{
            type: Input
        }], currentColumns: [{
            type: Input
        }], columnOrdering: [{
            type: Input
        }], childRows: [{
            type: Input
        }], page: [{
            type: Input
        }], filterable: [{
            type: Input
        }], columnFiltering: [{
            type: Input
        }], filter: [{
            type: Input
        }], showFilterPlaceholders: [{
            type: Input
        }], notifierService: [{
            type: Input
        }], localPagingSize: [{
            type: Input
        }], sortChange: [{
            type: Output
        }], filterChange: [{
            type: Output
        }], columnChange: [{
            type: Output
        }] }); })();
